/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserTaskStatus } from './UserTaskStatus';
import {
    UserTaskStatusFromJSON,
    UserTaskStatusFromJSONTyped,
    UserTaskStatusToJSON,
    UserTaskStatusToJSONTyped,
} from './UserTaskStatus';

/**
 * 
 * @export
 * @interface SetUserTaskStatusRequest
 */
export interface SetUserTaskStatusRequest {
    /**
     * 
     * @type {UserTaskStatus}
     * @memberof SetUserTaskStatusRequest
     */
    status: UserTaskStatus;
}



/**
 * Check if a given object implements the SetUserTaskStatusRequest interface.
 */
export function instanceOfSetUserTaskStatusRequest(value: object): value is SetUserTaskStatusRequest {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function SetUserTaskStatusRequestFromJSON(json: any): SetUserTaskStatusRequest {
    return SetUserTaskStatusRequestFromJSONTyped(json, false);
}

export function SetUserTaskStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetUserTaskStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': UserTaskStatusFromJSON(json['status']),
    };
}

export function SetUserTaskStatusRequestToJSON(json: any): SetUserTaskStatusRequest {
    return SetUserTaskStatusRequestToJSONTyped(json, false);
}

export function SetUserTaskStatusRequestToJSONTyped(value?: SetUserTaskStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': UserTaskStatusToJSON(value['status']),
    };
}

